import Head from 'next/head';
import PropTypes from 'prop-types';
import { Query, graphql } from 'react-apollo';
import React from 'react';
import { ParallaxProvider } from 'react-scroll-parallax';
import Breadcrumb from '../../src/components/Breadcrumb';
import { Container } from '../../src/components/Grid';
import { Header } from '../../src/components/Header';
import { Main, Page, Section } from '../../src/components/Layout';
import Watermark from '../../src/components/Parallax/Watermark';
import { withI18N } from '../../src/hoc/index';
import getMainSubjects from '../../src/apollo/graphql/contact/getMainSubjects';
import setSubjectsContact from '../../src/utils/collection/setSubjectsContact';
import createContext from '../../src/utils/format/createContext';
import ContactForm from '../../src/components/ContactForm';
import sendMail from '../../src/apollo/graphql/contact/sendMail';
import getContact from '../../src/apollo/graphql/contact/getContact';
import { Message } from '../../src/components/ContactForm/style';

class ContactPage extends React.PureComponent {
  state = {
    displayMessage: true,
    messageType: null,
    message: null
  };

  handleSubmit = async ({ name, email, message, subjectId, captcha }) => {
    const { t, sendMail } = this.props;
    if (captcha) {
      const response = await sendMail({
        variables: {
          email,
          name,
          message,
          subject_id: subjectId
        }
      });

      const { data } = response;
      if (data.createRequest) {
        window.scroll(0, 0);
        this.setState({
          displayMessage: true,
          messageType: 'info',
          message: t('common:contact.alerts.confirmation')
        });
      } else {
        this.setState({
          displayMessage: true,
          messageType: 'error',
          message: t('common:contact.alerts.unknownError')
        });
      }
    } else {
      this.setState({
        displayMessage: true,
        messageType: 'error',
        message: t('common:contact.alerts.error')
      });
    }
  };

  handleEmptyFields = () => {
    const { t } = this.props;
    this.setState({
      displayMessage: true,
      messageType: 'error',
      message: t('common:contact.alerts.error')
    });
  };

  render() {
    const { displayMessage, messageType, message } = this.state;
    const { t, i18n } = this.props;

    return (
      <Page contact>
        <Query query={getContact} context={createContext(i18n.language)}>
          {({ loading, error, data }) => {
            if (!loading && !error && data && data.getContact) {
              const page = data.getContact;
              return (
                <div>
                  <Head>
                    <link
                      rel="stylesheet"
                      href="/static/css/react-select-plus.css"
                    />
                    <title key="title">Grand Hôtel-Dieu</title>
                  </Head>
                  <Header
                    title={page.detail.title}
                    image={page.header_desktop}
                    imageMobile={page.header_mobile}
                  />
                  <Container>
                    <Breadcrumb
                      items={[
                        { href: '/', label: t('common:nav.tabs.home') },
                        { label: page.detail.title }
                      ]}
                    />
                  </Container>
                  <Main>
                    <Section>
                      <Container>
                        {displayMessage && (
                          <Message type={messageType}>{message}</Message>
                        )}
                        <Query
                          query={getMainSubjects}
                          context={createContext(i18n.language)}
                        >
                          {({ loading, error, data }) => {
                            if (
                              !loading &&
                              !error &&
                              data &&
                              data.getMainSubjects
                            ) {
                              const subjects = data.getMainSubjects;
                              const options = setSubjectsContact(subjects);
                              return (
                                <ContactForm
                                  subjects={options}
                                  onEmptyFields={this.handleEmptyFields}
                                  onSubmit={this.handleSubmit}
                                />
                              );
                            }

                            return null;
                          }}
                        </Query>
                      </Container>
                    </Section>
                  </Main>
                </div>
              );
            }

            return null;
          }}
        </Query>
      </Page>
    );
  }
}

ContactPage.propTypes = {
  sendMail: PropTypes.func
};

export default withI18N()(
  graphql(sendMail, {
    name: 'sendMail',
    options: ownProps => ({
      context: createContext(ownProps.i18n.language)
    })
  })(ContactPage)
);
